import { QueryClient } from "@tanstack/react-query";
import { ApiError } from "../lib/api-client";

/** Retry flaky networks, but never retry answers that won't change (403, 404, 422 …). */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) =>
          failureCount < 2 &&
          (!(error instanceof ApiError) || error.code === "NETWORK_ERROR" || error.status >= 500),
      },
      // A finished form submission (which may hold a password, a secret key or recovery codes)
      // is dropped as soon as its screen closes, not kept in memory for minutes.
      mutations: { retry: false, gcTime: 0 },
    },
  });
}
